import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import Layout from '../Layout';
import PageBanner from '../PageBanner';

import '../../styles/app.scss';
import * as styles from './PageLayout.module.scss';
import Seo from '../Seo';

interface PageLayoutProps {
  data: {
    title: string;
    subtitle: string;
  }
}

const PageLayout: FC<PageLayoutProps> = ({ children, data }) => {
  return (
    <Layout disableContainer>
      <Seo title={data.title} />
      <PageBanner title={data.title} subtitle={data.subtitle} />
      <Container>
        <div className={styles.content}>
          {children}
        </div>
      </Container>
    </Layout>
  );
};

export default PageLayout;